import { Injectable } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';
import { RestoreUrlService } from './restore.url.service';

@Injectable({
  providedIn: 'root',
})
export class HandleAuthErrorServiceService {
  constructor(
    private restoreUrl: RestoreUrlService,
    private router: Router,
  ) {}

  handleAuthError(urlSegments: UrlSegment[]) {
    if (urlSegments) {
      if (!urlSegments[0].path.includes('home')) {
        this.restoreUrl.addUrl(urlSegments);
      }
    }
    this.router.navigateByUrl('home').then();
  }
}
